(function(){
  'use strict';
  const norm=s=>String(s||'').toLocaleLowerCase().replace(/\s+/g,' ').replace(/[.\s]+$/,'').trim();

  function splitINCI(raw){
    const parts=[];let depth=0,start=0;
    for(let i=0;i<raw.length;i++){
      if('(['.includes(raw[i]))depth++;
      if(')]'.includes(raw[i]))depth=Math.max(0,depth-1);
      if((raw[i]===','||raw[i]===';')&&!depth){
        const numericLocant=raw[i]===','&&/^\s*\d+(?:\s*,\s*\d+)*\s*$/.test(raw.slice(start,i))&&/^\s*\d+(?:\s*,\s*\d+)*\s*[-\u2013]/.test(raw.slice(i+1));
        if(numericLocant)continue;
        parts.push(raw.slice(start,i).trim());start=i+1;
      }
    }
    parts.push(raw.slice(start).trim());return parts.filter(Boolean);
  }

  function toggleSelection(selected,item){
    const id=String(item.id);
    if(selected.some(p=>String(p.id)===id)){
      return {items:selected.filter(p=>String(p.id)!==id),limited:false};
    }
    return selected.length<2
      ? {items:[...selected,item],limited:false}
      : {items:selected,limited:true};
  }

  const sharedNames=(a,b)=>new Set(a.map(norm).filter(x=>b.some(y=>norm(y)===x)));

  if(typeof module!=='undefined'){
    module.exports={splitINCI,toggleSelection,sharedNames,norm};
  }

  if(typeof document==='undefined'||window.LoshenCompare)return;

  const configNode=document.querySelector('[data-lc-compare-config]');
  if(!configNode)return;

  const config=JSON.parse(configNode.textContent);

  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({
    '&':'&amp;',
    '<':'&lt;',
    '>':'&gt;',
    '"':'&quot;',
    "'":'&#39;'
  }[c]));

  const copy={
    en:{
      compare:'Compare',
      selected:'Selected',
      title:'Compare your two',
      add:'Choose one more product',
      remove:'Remove',
      limit:'You can compare two products. Remove one to choose another.',
      close:'Close comparison',
      purpose:'What it’s for',
      texture:'Texture',
      key:'Key ingredient notes',
      ingredients:'Full ingredient list',
      search:'Find an ingredient in both',
      common:'Highlight matching names',
      matching:'Matching ingredient name',
      none:'No matching ingredient names.',
      missing:'Ingredient list not yet available.',
      unavailable:'Details could not load. Open the product page or try again.',
      retry:'Try again',
      view:'View product',
      loading:'Loading product details…',
      source:'From the published product information. Ingredient names are matched as written; check the packaging for the latest formula.',
      option:'Formula / option',
      variantMissing:'No ingredient list saved for this option.',
      purposeMissing:'See the product page for details.',
      more:'Read more',
      less:'Read less'
    },
    fr:{
      compare:'Comparer',
      selected:'Sélectionné',
      title:'Comparez vos deux soins',
      add:'Choisissez un deuxième produit',
      remove:'Retirer',
      limit:'Vous pouvez comparer deux produits. Retirez-en un pour en choisir un autre.',
      close:'Fermer la comparaison',
      purpose:'À quoi sert-il?',
      texture:'Texture',
      key:'Notes sur les ingrédients clés',
      ingredients:'Liste complète des ingrédients',
      search:'Chercher un ingrédient dans les deux',
      common:'Surligner les noms identiques',
      matching:'Nom d’ingrédient identique',
      none:'Aucun nom d’ingrédient correspondant.',
      missing:'Liste des ingrédients non disponible.',
      unavailable:'Impossible de charger les détails. Consultez le produit ou réessayez.',
      retry:'Réessayer',
      view:'Voir le produit',
      loading:'Chargement des détails…',
      source:'Selon les informations publiées du produit. Les noms sont comparés tels qu’ils sont écrits; consultez l’emballage pour la formule actuelle.',
      option:'Formule / option',
      variantMissing:'Aucune liste enregistrée pour cette option.',
      purposeMissing:'Consultez la page du produit pour les détails.',
      more:'Lire la suite',
      less:'Réduire'
    }
  };

  let selected=[],records=[],lastFocus,request=0;
  const cache=new Map();

  const lang=()=>document.documentElement.lang.startsWith('fr')?'fr':'en';
  const t=k=>copy[lang()][k];
  const storageKey='loshen.compare.v1.'+config.mode;

  try{
    const saved=JSON.parse(sessionStorage.getItem(storageKey)||'[]');
    if(Array.isArray(saved)){
      selected=saved.filter(p=>
        p&&
        /^\d+$/.test(String(p.id))&&
        typeof p.title==='string'&&
        typeof p.url==='string'&&
        /^https?:\/\/www\.loshen\.ca\/|^\/(?:fr\/)?products\//.test(p.url)
      ).slice(0,2);
    }
  }catch{}

  const status=document.createElement('div');
  status.className='lc-compare-status';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  document.body.append(status);

  const tray=document.createElement('aside');
  tray.className='lc-compare-tray';
  tray.hidden=true;
  document.body.append(tray);

  const dialog=document.createElement('dialog');
  dialog.className='lc-compare-dialog';
  dialog.setAttribute('aria-labelledby','lc-compare-title');
  document.body.append(dialog);

  function announce(message){
    status.textContent='';
    requestAnimationFrame(()=>status.textContent=message);
    clearTimeout(announce.timer);
    announce.timer=setTimeout(()=>status.textContent='',5500);
  }

  function refreshButtons(){
    document.querySelectorAll('[data-lc-compare]').forEach(b=>{
      const active=selected.some(p=>String(p.id)===b.dataset.lcCompare);
      b.setAttribute('aria-pressed',String(active));
      b.textContent=t(active?'selected':'compare');
      b.setAttribute(
        'aria-label',
        t(active?'remove':'compare')+' '+(b.dataset.title||'')
      );
    });
  }

  function refresh(){
    tray.hidden=!selected.length;
    tray.setAttribute('aria-label',t('compare'));

    tray.innerHTML=`<div class="lc-compare-slots">${selected.map(p=>`<div class="lc-compare-slot"><span>${esc(p.title)}</span><button type="button" data-lc-remove="${esc(p.id)}" aria-label="${esc(t('remove')+' '+p.title)}">×</button></div>`).join('')}${selected.length===1?`<span class="lc-compare-invite">${t('add')}</span>`:''}</div><button type="button" class="lc-compare-open" ${selected.length<2?'disabled':''}>${t('compare')} (${selected.length}/2)</button>`;

    document.body.classList.toggle('lc-has-comparison',!!selected.length);
    refreshButtons();

    try{
      sessionStorage.setItem(storageKey,JSON.stringify(selected));
    }catch{}
  }

  function plain(value){
    const doc=new DOMParser().parseFromString(String(value||''),'text/html');
    doc.querySelectorAll('script,style').forEach(n=>n.remove());
    return doc.body.textContent.replace(/\s+/g,' ').trim();
  }

  const field=(p,key)=>p[key]?.jsonValue??p[key]??'';

  function extractSection(doc,pattern){
    const nodes=[...doc.body.querySelectorAll('h2,h3,h4,h5,h6,p')];
    const head=nodes.find(n=>pattern.test(n.textContent.trim()));
    if(!head)return '';

    let result=[],next=head.nextElementSibling;

    while(next&&!/^H[1-6]$/.test(next.tagName)){
      result.push(next.textContent.trim());
      next=next.nextElementSibling;
    }

    return result.join(' ').trim();
  }

  function normalizeRecord(raw){
    const doc=new DOMParser().parseFromString(
      raw.descriptionHtml||'',
      'text/html'
    );

    doc.querySelectorAll('script,style').forEach(n=>n.remove());

    const localized=key=>
      field(raw,lang()==='fr'?key+'Fr':key)||field(raw,key);

    const savedINCI=plain(field(raw,'inci'));

    let inci=savedINCI||extractSection(
      doc,
      /^(?:full ingredients? list|full list of ingredients|liste complète des ingrédients|liste des ingrédients|inci)\s*:?$/i
    );

    if(
      inci&&
      (
        (!savedINCI&&!inci.includes(','))||
        /please refer|consultez|refer to each/i.test(inci)
      )
    ){
      inci='';
    }

    const keys=localized('keyIngredients');

    return {
      ...raw,
      summary:plain(localized('summary'))||
        doc.querySelector('p')?.textContent.trim()||
        '',
      texture:plain(localized('texture')),
      keyIngredients:Array.isArray(keys)?keys.map(plain):[],
      inci,
      variants:Array.isArray(raw.variants)?raw.variants:[],
      variantIndex:0
    };
  }

  async function loadProduct(p){
    const key=lang()+':'+p.id;
    if(cache.has(key))return cache.get(key);

    let result;

    if(config.mode==='preview'){
      if(!loadProduct.snapshot){
        loadProduct.snapshot=fetch('compare-data.json')
          .then(r=>{
            if(!r.ok)throw Error('data');
            return r.json();
          })
          .catch(e=>{
            loadProduct.snapshot=null;
            throw e;
          });
      }

      result=(await loadProduct.snapshot)[p.id];
      if(!result)throw Error('missing');
    }else{
      const url=new URL(p.url,location.origin);
      url.search='';
      url.searchParams.set('view','lc-compare-data');

      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok)throw Error('data');

      const doc=new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const node=doc.querySelector('[data-lc-compare-data]');
      if(!node)throw Error('missing');

      result=JSON.parse(node.getAttribute('data-lc-compare-data'));
    }

    const normalized=normalizeRecord(result);
    cache.set(key,normalized);
    return normalized;
  }

  function currentINCI(p){
    if(!p)return '';
    if(p.variants.length)return plain(p.variants[p.variantIndex]?.inci);
    return p.inci;
  }

  function renderIngredients(){
    const q=norm(
      dialog.querySelector('[data-lc-ingredient-search]')?.value
    );

    const highlight=dialog.querySelector('[data-lc-highlight]')?.checked;
    const lists=records.map(p=>splitINCI(currentINCI(p)));
    const common=sharedNames(lists[0]||[],lists[1]||[]);

    dialog.querySelectorAll('[data-lc-ingredient-list]').forEach((el,i)=>{
      const p=records[i];
      const items=(lists[i]||[]).filter(x=>norm(x).includes(q));

      el.innerHTML=!lists[i]?.length
        ? `<p class="lc-compare-muted">${t(p?.variants.length?'variantMissing':'missing')}</p>`
        : !items.length
          ? `<p>${t('none')}</p>`
          : `<ol>${items.map(x=>`<li>${highlight&&common.has(norm(x))?`<mark title="${esc(t('matching'))}">${esc(x)}</mark>`:esc(x)}</li>`).join('')}</ol>`;
    });
  }

  function renderDialog(){
    dialog.innerHTML=`<header class="lc-compare-header"><h2 id="lc-compare-title">${t('title')}</h2><button type="button" data-lc-close aria-label="${t('close')}">×</button></header><div class="lc-compare-columns">${selected.map((p,i)=>`<div class="lc-compare-product">${p.image?`<img src="${esc(p.image)}" alt="" width="100" height="100">`:''}<h3>${esc(p.title)}</h3><a href="${esc(p.url)}" ${config.mode==='preview'?'target="_blank" rel="noopener"':''}>${t('view')}</a>${records[i]===null?`<p>${t('unavailable')}</p><button type="button" data-lc-retry>${t('retry')}</button>`:''}</div>`).join('')}</div>
    <h3 class="lc-compare-row-title">${t('purpose')}</h3><div class="lc-compare-columns">${records.map(p=>`<div class="lc-compare-copy"><p>${esc(p?.summary||t('purposeMissing'))}</p>${p?.texture?`<p><strong>${t('texture')}</strong><br>${esc(p.texture)}</p>`:''}${p?.keyIngredients.length?`<details><summary>${t('key')}</summary><ul>${p.keyIngredients.map(k=>`<li>${esc(k)}</li>`).join('')}</ul></details>`:''}</div>`).join('')}</div>
    <h3 class="lc-compare-row-title">${t('ingredients')}</h3><div class="lc-compare-tools"><label><span class="lc-compare-sr">${t('search')}</span><input type="search" data-lc-ingredient-search placeholder="${t('search')}"></label><label><input type="checkbox" data-lc-highlight checked> ${t('common')}</label></div>
    <div class="lc-compare-columns">${records.map((p,i)=>`<div>${p?.variants.length?`<label class="lc-compare-variant">${t('option')}<select data-lc-variant="${i}">${p.variants.map((v,j)=>`<option value="${j}">${esc(v.title)}</option>`).join('')}</select></label>`:''}<div data-lc-ingredient-list="${i}"></div></div>`).join('')}</div><p class="lc-compare-source">${t('source')}</p>`;

    renderIngredients();
  }

  async function open(){
    if(selected.length!==2)return;

    const token=++request;

    if(!dialog.open){
      lastFocus=document.activeElement;
      dialog.showModal();
      document.body.classList.add('lc-comparison-open');
    }

    dialog.innerHTML=`<header class="lc-compare-header"><h2 id="lc-compare-title">${t('title')}</h2><button type="button" data-lc-close aria-label="${t('close')}">×</button></header><p role="status">${t('loading')}</p>`;

    records=await Promise.all(
      selected.map(p=>
        loadProduct(p)
          .then(r=>({...r}))
          .catch(()=>null)
      )
    );

    if(token!==request||!dialog.open)return;

    renderDialog();
    dialog.querySelector('[data-lc-close]').focus();
  }

  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-lc-compare]');

    if(button){
      const item={
        id:button.dataset.lcCompare,
        title:button.dataset.title,
        url:button.dataset.url,
        image:button.dataset.image
      };

      const result=toggleSelection(selected,item);

      if(result.limited){
        announce(t('limit'));
        return;
      }

      selected=result.items;
      refresh();

      announce(
        selected.length===1
          ? t('add')
          : t('compare')+' ('+selected.length+'/2)'
      );
    }

    const remove=event.target.closest('[data-lc-remove]');

    if(remove){
      selected=selected.filter(
        p=>String(p.id)!==remove.dataset.lcRemove
      );
      refresh();
      tray.querySelector('button')?.focus();
    }

    if(event.target.closest('.lc-compare-open'))open();
    if(event.target.closest('[data-lc-close]'))dialog.close();
    if(event.target.closest('[data-lc-retry]'))open();
  });

  dialog.addEventListener('input',event=>{
    if(event.target.matches('[data-lc-ingredient-search],[data-lc-highlight]')){
      renderIngredients();
    }
  });

  dialog.addEventListener('change',event=>{
    if(event.target.matches('[data-lc-variant]')){
      records[Number(event.target.dataset.lcVariant)].variantIndex=
        Number(event.target.value);
      renderIngredients();
    }
  });

  dialog.addEventListener('click',event=>{
    if(event.target===dialog){
      const b=dialog.getBoundingClientRect();

      if(
        event.clientX<b.left||
        event.clientX>b.right||
        event.clientY<b.top||
        event.clientY>b.bottom
      ){
        dialog.close();
      }
    }
  });

  dialog.addEventListener('close',()=>{
    request++;
    document.body.classList.remove('lc-comparison-open');
    if(lastFocus?.isConnected)lastFocus.focus();
  });

  new MutationObserver(mutations=>{
    if(
      mutations.some(m=>
        [...m.addedNodes].some(n=>
          n.nodeType===1&&
          (
            n.matches?.('[data-lc-compare]')||
            n.querySelector?.('[data-lc-compare]')
          )
        )
      )
    ){
      refreshButtons();
    }
  }).observe(document.body,{childList:true,subtree:true});

  window.LoshenCompare={refreshButtons,setLanguage:refresh,compareProducts(items){
    if(!Array.isArray(items)||items.length!==2||items.some(item=>!/^\d+$/.test(String(item.id))||!/^\/(?:fr\/)?products\//.test(item.url)))return;
    selected=items.map(item=>({...item,id:String(item.id)}));refresh();open();
  }};
  refresh();
})();

